/**
 * location.js
 */

import Geocode from 'react-geocode';



const processGeocodeResult = (location, latitude, longitude) => {
  let streetNumber = '';
  let street = '';
  let city = '';
  let region = '';
  let country = '';
  let postCode = '';

  for (let i = 0; i < location.address_components.length; i++) {
    const type = location.address_components[i].types[0];
    const value = location.address_components[i].short_name;

    switch (type) {
      case 'street_number':
        streetNumber = value;
        break;

      case 'route':
        street = value;
        break;

      case 'locality':
        city = value;
        break;

      case 'administrative_area_level_1':
        region = value;
        break;

      case 'country':
        country = value;
        break;

      case 'postal_code':
        postCode = value;
        break;

      default:
        break;
    }
  }

  return {
    streetNumber,
    street,
    city,
    region,
    country,
    postCode,
    latitude,
    longitude
  };
}


const geocodeCoordinates = async (latitude, longitude, apiKey) => {
  Geocode.setApiKey(apiKey);
  const response = await Geocode.fromLatLng(latitude, longitude);
  if (response) {
    let bestResult = response.results.find(result => {
      return result.address_components.find(component => component.types.includes('street_number'));
    });
    bestResult = bestResult || response.results[0];
    return processGeocodeResult(bestResult, latitude, longitude);
  }
}


export const getCoordinatesViaBrowser = () => {
  return new Promise((resolve, reject) => {
    const success = (obj) => {
      resolve(obj.coords);
    }

    try {
      navigator.geolocation.getCurrentPosition(success, reject);
    } catch (e) {
      reject(e);
    }
  });
}


// attempts to get current coordinates.
// if called in the app context this attempts to use app bglocation library,
// otherwise it uses browser/navigator geolocation call.
export const getCurrentCoordinates = (getLocation) => {
  return new Promise(async (resolve, reject) => {
    let isResolved = false;
    let fallbackTimeout = null;

    try {
      if (window.ReactNativeWebView) {
        // give the plugin time to get the position otherwise use fallback
        fallbackTimeout = setTimeout(async () => {
          const browserLocation = await getCoordinatesViaBrowser();
          if (!isResolved) {
            isResolved = true;
            resolve(browserLocation);
          }
        }, 30000);

        const gpsLocation = await getLocation('address');
        clearTimeout(fallbackTimeout);
        if (!isResolved) {
          isResolved = true;
          resolve(gpsLocation);
        }
      }
      else {
        resolve(await getCoordinatesViaBrowser());
      }
    } catch (e) {
      reject(e);
    }
  });
}


// gets current address and coordinates
export const getCurrentAddress = async (apiKey, getLocation) => {
  const location = await getCurrentCoordinates(getLocation);
  return await geocodeCoordinates(location.latitude, location.longitude, apiKey);
}


export const getCoordinatesFromAddress = async (address, apiKey) => {
  Geocode.setApiKey(apiKey);
  const response = await Geocode.fromAddress(address);
  const { lat, lng } = response.results[0].geometry.location;

  return { 
    latitude: lat, 
    longitude: lng 
  };
}